import React from 'react';
import Header from '../../01-atoms/text/Heading.component';
import bem from '../../_utils/bem';

var PageTitle = function PageTitle(_ref) {
  var modifiers = _ref.modifiers,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: bem('page-title', 'wrapper', modifiers)
  }, /*#__PURE__*/React.createElement(Header, {
    level: 1,
    block: "page-title"
  }, children));
};

export default PageTitle;